export enum WidgetsState {
  'OPEN' = 'OPEN',
  'CLOSED' = 'CLOSED',
}
